export function cardContainerClassName(highlighted: boolean): string {
  return `overflow-hidden rounded-xl border transition-all ${
    highlighted
      ? 'border-prim-300 bg-prim-50'
      : 'border-neut-border bg-neut-bg-alt'
  }`;
}

export function cardHeaderClassName(disabled: boolean): string {
  return `flex items-center gap-3 px-4 py-3 transition-colors ${
    disabled ? '' : 'hover:bg-neut-50'
  }`;
}

export function selectableCardContainerClassName(selected: boolean): string {
  return `overflow-hidden rounded-xl border transition-all ${
    selected
      ? 'border-prim bg-prim-50 ring-1 ring-prim'
      : 'border-neut-border bg-neut-bg-alt'
  }`;
}
